module.exports = __webpack_public_path__ + "img/icon5.9fb29229.svg";